export const sortStrings = (a: string | null, b: string | null) =>
  (a || '').localeCompare(b || '');
